import { TableWithStoredSettingsAndLayoutSettings } from '@Components/Tables/TableWithStoredSettingsAndLayoutSettings';
import { BILLING_API } from '@Constants/backendConstants';
import { Permission } from '@Constants/Permission.g';
import { useHasPermission } from '@Contexts/appContext';
import { type EnumPriceListType, getPriceListTypeName, priceListOptions, ApiPriceList } from '@Model';

import { Column, useTranslate } from '@synqo/frontend-component-library';
import { EnumFrontendLayoutSetting } from '@Model';
import { useMemo } from 'react';
import { useListApi } from '@Hooks/useListApi';
import { PriceListsRepository } from '@Repositories/Billing';

export function FrameListPriceList() {
    const hasPermission = useHasPermission();
    const i18n = useTranslate('');

    const priceListColumns: Column<ApiPriceList>[] = useMemo(
        () => [
            { name: 'shorthand', label: i18n('Suchcode') },
            {
                name: 'type',
                label: 'Art',
                filterVariant: 'select',
                filterOptions: priceListOptions,
                renderCell: ({ cellData }) => getPriceListTypeName(cellData as EnumPriceListType),
            },
        ],
        [i18n],
    );

    const module = useListApi(PriceListsRepository, BILLING_API);

    return (
        <TableWithStoredSettingsAndLayoutSettings
            layoutSettingsContext={EnumFrontendLayoutSetting.PriceListsTableLayout}
            name="PriceListsList"
            columns={priceListColumns}
            loader={module.loadPage}
            canCreate={hasPermission(Permission.BillingPriceListsCreate)}
            useOnClickNavigation
            fullSize
        />
    );
}
